import React , {Fragment, useEffect , useState} from "react";
import * as s from './RenameFolder.style';
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../../../../components/shared/inputs/FormikControl";
import Spinner from '../../../../components/shared/spinner/Spinner';
// images
import logo from "../../../../assets/images/logo.png";

import * as actions from "../../../../store/actions/index";
import {  useSelector, useDispatch } from "react-redux";
import { useParams, useHistory , useLocation } from "react-router-dom";

const RenameFolder = () => {
    let {folderId} = useParams();
    let {folderName} = useParams();
    let dispatch = useDispatch();
    const history = useHistory();
    let folderLoading = useSelector((state) => state.forClientFolders.loading);
    console.log(folderLoading);
    
  const [formValues , setFormValues] = useState(null)

  useEffect(() =>{
    if(folderLoading ===false){
      setFormValues({
        folderName: folderName,
      })
    }
  },[folderLoading])

    const initialValues = {
        folderName: ""
      };

      const validationSchema = Yup.object({
        newFolderName: Yup.string().required("Required")
      });
     

      const onSubmit = (values) => {
        console.log("Form data", values);
       dispatch(actions.renameFolder(folderId,values,() => history.go(-2)));
        
      };
    





    return(
    <s.ScreenContainer>
        <s.Container>
            {/* {folderLoading === false || folderLoading === null ? ( */}
            <Fragment>
<s.LogoContainer>
          <s.LogoImage src={logo} />
          
        </s.LogoContainer>

        <s.FormContainer>
          
          <Formik
            initialValues={formValues || initialValues}
            // validationSchema={validationSchema}
            onSubmit={onSubmit}
            enableReinitialize 
          >
            {(formik) => {
              return (
               
                
                <Form>
                  <s.H1>Rename Folder</s.H1>
                  <s.InputContainer>
                    <FormikControl
                     
                      control="input"
                      // control='chakraInput'
                      type="text"
                      name="folderName"
                      placeholder="NEW FOLDER NAME"
                    />
                    
                  </s.InputContainer>
                  <s.Div>
                    <s.RenameBtn type="submit" disabled={!formik.isValid}>
                      Rename
                    </s.RenameBtn>
                  </s.Div>
                </Form>
              );
            }}
          </Formik>
        </s.FormContainer>

            </Fragment> 
            {/* )  :  (
                <s.SpinnerContainer>
                  <Spinner />
               </s.SpinnerContainer>
      )}; */}
                    </s.Container>
    </s.ScreenContainer>
    )
    
};

export default RenameFolder;